import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';

import { Wrapper, WrapperStd, Icon, Title, Label } from './elements';
import Spa08 from 'dc/Spa08';
import MSB001 from './MSB001';
import { useText } from 'common/hooks';

const deps = {
  isLoadingTeamsData: state.challenge.isLoading.teamsData,
  team: state.challenge.campaign.structure.sections[
    state.challenge.userCampaign.sectionKey
  ].teams[state.challenge.userCampaign.teamKey],
};

export function TeamList({
  isLoadingTeamsData,
  team,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <Wrapper>
      <WrapperStd>
        <Icon icon="icon-team" />
        <Spa08 />
        <Title>{isLoadingTeamsData ? '-' : team.name}</Title>
        <Spa08 />
        <Label icon="icon-people">
          {t('challenge.FeC1.members_in_your_team', {
            smart_count: team?.participantCount ?? 0,
          })}
        </Label>
      </WrapperStd>
      <MSB001 />
    </Wrapper>
  );
}

export default connect(deps, TeamList);
